import firebase from '../config/firebase.config';

export const subscribeToIntegrationImportLogs = (
  companyId,
  integrationDocId,
  onUpdate
) => {
  return firebase
    .firestore()
    .collection('companyDatabase')
    .doc(companyId)
    .collection('integrations')
    .doc(integrationDocId)
    .collection('importLogs')
    .orderBy('importedAt', 'desc')
    .limit(10)
    .onSnapshot(
      (snap) => {
        const logs = snap.docs.map((d) => {
          const data = d.data();
          return {
            id: d.id,
            importedAt: data.importedAt?.toDate?.() ?? null,
            importedBy: data.importedBy || {},
            source: data.source || integrationDocId,
            status: data.status || 'completed',
            durationMs: data.durationMs || 0,
            stats: data.stats || {},
          };
        });
        onUpdate(logs);
      },
      (err) => {
        console.error(`[${integrationDocId}] import logs listener error:`, err);
        onUpdate([]);
      }
    );
};

export const getIntegrationImportLogDetails = async (
  companyId,
  integrationDocId,
  logId
) => {
  const doc = await firebase
    .firestore()
    .collection('companyDatabase')
    .doc(companyId)
    .collection('integrations')
    .doc(integrationDocId)
    .collection('importLogs')
    .doc(logId)
    .collection('details')
    .doc('data')
    .get();
  return doc.exists ? doc.data() : { employees: [] };
};
